import ContentContainer from "@/src/components/containers/ContentContainer";
import GenericHead from "@/src/components/Head/GenericHead";
import VCCalculator from "@/src/components/VCCalculator";
import Image from "next/image";
import { useState } from "react";

const VCLoopHole = () => {
  return (
    <>
      <GenericHead
        title={"VC Loophole Calculator"}
        description={"Vice captain loophole calculator"}
      />
      <div className="bg-white">
        <ContentContainer bgColor="white">
          <h1>Vice Captain Loophole Calculator</h1>
        </ContentContainer>
        <ContentContainer bgColor="scpb-blue">
          <VCCalculator />
        </ContentContainer>

        <ContentContainer bgColor="white">
          <div className="flex flex-col gap-2 bg-white">
            <h2>What is the Loophole?</h2>
            <p>
              The loophole is a method used to maximise scoring in your
              Supercoach team, based on the way the game has been set-up. <br />
              There are two types of loopholing you need to be aware of:
              <ul className="list-disc font-bold">
                <li>Auto-emergency loophole</li>
                <li>Captaincy loophole</li>
              </ul>
              Both types utilise the same concept, but are used for different
              practices within the game.
            </p>
            {/* <h3 className="text-large font-bold">Auto-emergency loophole</h3> */}
            {/* <div className="flex flex-col gap-2">
              <p>
                Note that loopholing only works if you have at least one
                non-active player in your squad. That may be a player whose team
                is on the bye, an injured player, or a player that doesn’t get
                picked in the team.{" "}
              </p>
              <p>
                In Supercoach, only the scores of the starting eleven players
                you choose to play in your team each round count towards your
                team total for that round.{" "}
              </p>
              <p>
                The five players on your bench score points, and will alter
                value as a result, but their scores won’t count towards your
                total.
              </p>
              <p> Unless you know how to loop… </p>
              <p>
                You are able to select three emergency players on your bench by
                selecting the purple E icon when hovering over the player’s
                name.
              </p>
              <p>
                If a player in your starting team from the same position is
                ruled out of their game and doesn’t score points, the player you
                select on your bench as the emergency (E) will automatically
                come into your starting team on completion of the round as a
                replacement to the player who was ruled out.
              </p>
              <p>
                It’s important to note that the auto-emergency system differs to
                NRL Supercoach.
              </p>
              <p>
                In NRL Supercoach, when a player is ruled out you get the lowest
                scoring player from your entire bench.{" "}
              </p>
              <p>
                In BBL Supercoach, the player you have selected in that position
                (BAT, BOWL, WKP) as your AE will come into your team.
              </p>
              <p>This is how you use it.</p>{" "}
              <p>
                Let’s assume the five players on your bench are all active and
                playing for their respective team in the upcoming game.
              </p>{" "}
              <p>
                The first thing to note is the timing of when each team plays in
                the corresponding round. This is important and absolutely
                crucial to be aware of before the round starts.
              </p>
              <p>As an example, I’ll use Supercoach BBL 2023, round 2. </p>
              <p>
                (Side note: Round 1 has five teams playing two games or more,
                this is a complete anomaly in Supercoach and makes the loophole
                largely ineffective, so ignore it.)
              </p>
              <div className="w-full relative">
                <img
                  alt="Supercoach example round"
                  src="https://blog.scplaybook.com.au/wp-content/uploads/2023/12/Screenshot-2023-12-01-at-2.50.43-pm-640x431.png"
                />
              </div>
              <p>
                To use the loophole, it’s vital your emergency player is in an
                early game in the round.
              </p>
              <p>
                Ideally game one, game two is generally also okay. Let’s use the
                below team as an example.
              </p>
              <div className="w-full relative ">
                <img
                  alt="Supercoach example round"
                  src="https://blog.scplaybook.com.au/wp-content/uploads/2023/12/Screenshot-2023-12-01-at-2.51.07-pm-640x924.png"
                />
              </div>
              <p>
                The wicket-keeper slot is always a good opportunity to loop.
              </p>
              <p>
                Scorchers player Sam Whiteman plays in game two of the round, so
                you put the emergency on him.
              </p>
              <p>
                If he scores well, let’s say 75 points, technically it won’t
                count to your score as he’s on your bench.
              </p>
              <p>
                However, the Melbourne Stars are on the bye, meaning
                wicket-keeper batsmen Sam Harper isn’t playing.
              </p>
              <p>
                As he is a dual position player (WKP-BAT), as is Quinton de
                Kock, you can switch Harper up into the starting wicket-keeper
                slot.
              </p>
              <p>
                When the round finalises, the game identifies Harper’s 0 points
                as ‘did not play’, and automatically plugs in Whiteman into that
                spot, meaning his 75 points will count towards your total.
              </p>
              <p className="font-bold">Here’s where we find joy in the loop.</p>
              <p>
                If Whiteman scores poorly, you simply leave de Kock in the
                wicket-keeping spot for his impending score.
              </p>
              <p>
                (Note in the above example you would still need to replace
                Harper on the bench as he’s not playing).
              </p>
              <p>
                So you’ve had a risk-free crack at Whiteman, essentially giving
                you two opportunities to get a good score for that spot.
              </p>
              <p>
                This can also be done for the batting and bowling positions.
              </p>
              <p>
                If the scenario was to play out where all three of your
                emergencies scored well and you wanted to loop all three, you
                would of course have to have three players who aren’t active
                that round to initiate the loop.
              </p>
            </div> */}
            {/* <h3 className="text-large font-bold">Captaincy Loophole</h3>
            <div className="flex flex-col gap-2">
              <p>
                The captaincy loophole works essentially in the same manner as
                explained above, with a few minor tweaks.
              </p>
              <p>
                For this example, let’s use the round 3 fixtures and an adjusted
                team.
              </p>
              <div className="w-full flex">
                <img
                  alt="Supercoach example round"
                  src="https://blog.scplaybook.com.au/wp-content/uploads/2023/12/Screenshot-2023-12-01-at-2.51.22-pm-640x420.png"
                />
              </div>
              <div className="w-full ">
                <img
                  alt="Supercoach example round"
                  src="https://blog.scplaybook.com.au/wp-content/uploads/2023/12/Screenshot-2023-12-01-at-2.51.43-pm-640x847.png"
                />
              </div>
              <p>
                It’s vital for it to work that you put the vice-captaincy (VC)
                option on a player that plays in a game before your selected
                captain.
              </p>
              <p>
                Glenn Maxwell and the Stars play game one, so let’s put the
                vice-captaincy on him.
              </p>
              <p>
                If VC Maxwell scores well in their first game of the round,
                let’s say he scores 75, you can lock in that player as your
                captain for the week.
              </p>
              <p>
                To do so, you would then have to bring a non-active player into
                your starting team, and give them the captaincy.
              </p>
              <p>
                In this round, the Brisbane Heat have the bye, so Spencer
                Johnson would be great for this.
              </p>
              <p>
                You would bring Johnson into your team for your weakest option,
                let’s say Cooper Connolly, and you would captain Johnson.
              </p>
              <p>
                When the round finishes, the game would note Johnson’s 0 points
                and automatically make Maxwell your captain, doubling his strong
                score.
              </p>
              <p>
                If Maxwell failed in his first game, you simply leave the
                captaincy on Adam Zampa or another player of choice.
              </p>
              <p>
                When using the loophole, the varying fixtures for every
                Supercoach round play a significant role.
              </p>
              <p>
                Some rounds, there’s ample opportunity to use the loophole,
                while on other rounds it may be impractical and much harder to
                do so.
              </p>
            </div>
            <div className="flex flex-col gap-2">
              <h3>Key notes to remember for both methods</h3>
              <ul className="list-disc">
                <li>
                  Select one auto-emergency player in each position (BAT, BOWL,
                  WKP).
                </li>
                <li>
                  Auto-emergency player must be in an early game of the round
                  for it to work. Before each round, run through the scenario to
                  make sure you have someone to replace them with if they score
                  well.
                </li>
                <li>
                  You need at least one player who is non-active in the
                  corresponding round for it to work.
                </li>
                <li>
                  Said player needs to play after your selected auto-emergency
                  option for that round.
                </li>
              </ul>
            </div>
           */}
           </div>
        </ContentContainer>
      </div>
    </>
  );
};

export default VCLoopHole;
